import {useNavigate, useSearchParams} from "react-router-dom";
import React, {useState} from "react";
import styled from "@emotion/styled/macro";
import BigScreenCommunity3D, {IBigScreenCommunity3DItems} from "../../../unreal/BigScreenCommunity3D";
import {IImages, ISlsOrd} from "../../../kova/slsordClient";
import PurchaseOverlay, {RegistrationOverlay} from "../../reservation/PurchaseOverlay";
import {useUserContext} from "../../../context/userContext";
import {useReservationClient} from "../../../data/slsOrdSource";
import {getCameraPrefixForSlsOrd} from "../../../unreal/CameraController";

import {ReactComponent as EmptyHeart} from "../../../img/EmptyHeart.svg";
import {ReactComponent as Favorite} from "../../../img/SmallHeart.svg";

import {ThemeColors} from "../../layout/GlobalLayout";
import {useDataInvalidation} from "../../../App";
import {CameraCard} from "../vscFindYourHome/CameraCards";
import {getItemsForTab, useModelConfig} from "./UseModelConfig";
import {ViewTabs} from "../../ViewTabs";
import FurnitureSwitch from "./FurnitureSwitch";
import {PlanLayout} from "../plan/Plan";
import {BigScreenCommunityMap} from "../communitymap/BigScreenCommunityMap";
import {VscBigScreenWebPage} from "../../content/ButtonComponent";
import {useVscContext} from "../../content/VscReactContext";
import BigScreenWebPage from "../../../unreal/BigScreenWebPage";

export const SiteSpecificDiv = styled.div`
display:flex;
  overflow:hidden;
  flex-direction:row;
  height:100%;
  > * {
    flex: 1 1 1px;
    align-items: stretch;
  }
  .views {
    padding:16px;
    overflow-y:scroll;
    
    .furnitureswitch {
      margin-top: 20px;
    }
    h2 { text-transform: uppercase;}
    flex-grow: 1;
    display:flex;
    flex-direction: column;
    flex-basis: 209px;
    background-color: white;
    .button {
      text-transform: none;

    }
    .cameras {
      margin-top:32px;
      button {
        height: 200px;
        width: 200px;
      }
      display:flex;
      flex-wrap: wrap;gap: 32px;
    }
  }
  .selections {
    background-color: var(--content-background);
  }
  .views .viewbuttons {
    
    flex-grow:1;
  }
  
  .selections {
    max-width: 300px;
    display:flex;
    
    justify-content:center;
    > * {
      
    }
  }

  .back {
  
    text-decoration: none;
    font-weight: bold;
    color: var(--secondary-color);
    align-self: center;
    margin-bottom:20px;
  }
   .controls {
     text-transform: none;

     margin-top:24px;
     margin-left:auto;
     margin-right:auto;
    justify-self: center;
     align-self: center;
    height:45px;
    display:flex;
     font-size:10px;
    background-color: ${ThemeColors.platinum};
    border-radius:8px;
    width:145px;
    > * {
      display: flex;
      align-items: center;
      justify-content:center;
      width: 50%;
    }
    .selected {
      box-shadow: 0px 0px 1px rgba(20, 20, 20, 0.04), 0px 0px 8px rgba(20, 20, 20, 0.08);
      border-radius: 6px;
      background-color: white;
    }
    top: 32px;
    
  }
  .furnitureswitch {
    
  }
  
`

const OptionLine: React.FC<{optionName: string}> = (props) => {

    const { optionName } = props;
    return <p className={"item"}><img src={"/images/check.svg"} /> <span>{optionName}</span></p>
}
const SiteSpecificSelectionsDiv = styled.div`
display:flex; 
  min-height:100%;
  max-width:243px;
  justify-content: space-between;
  flex-direction: column;
  .mainContent {
    overflow-y: scroll;
    margin-top: 32px;
  }
  .reserve {
    
    padding-bottom:32px; align-self: center;
    button {
      color: white;
      background-color: var(--primary-color);
      border-radius: 50px;
      padding: 14px 32px;
      border:0;
      
    }
  }
  h4 {
    font-weight: 400; font-style: normal; font-size: 18px; line-height: 25px;
  
  }
  .title {
    display:flex;
    position:relative;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    line-height:22px;
    font-weight:400;
    text-transform: uppercase;
    
    svg {
      left:0;
      height:100%;
      position:absolute;
    }
  }
  .item {
    margin-top:10px;
    margin-bottom:0;

    word-break: break-word;
    img {
      margin:10px;
    }
    
    min-height: 38px;
    display:flex;
    justify-content:flex-start;
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    align-items: center;
    background-color: white;
    
  }
`


export const optionsToBeShown = ["MCH_HVAC", "WH_DESIGNPKG", "GARAGE"];
export const SiteSpecificSelections: React.FC<{slsOrd: ISlsOrd, isFavorite: boolean, setFavorite:(val:boolean) => void}> = (props) => {
    const { slsOrd, isFavorite, setFavorite } = props;
    const [isReserving, setReserving] = useState<boolean>(false);
    const [isConfirming, setConfirming] = useState<boolean>(false);
    const [isRegistering, setRegistering] = useState(false);
    const userContext = useUserContext();
    const reservationClient = useReservationClient();
    const invalidateData = useDataInvalidation();

    const navigate = useNavigate();
    async function leaveWaitlist() {
        const user = userContext.user;
        if (user === undefined) return;
        setConfirming(true);
        try {
            await reservationClient.leaveWaitlist(slsOrd, user);
            await invalidateData();
        } finally {
            setConfirming(false);
        }
    }
    function startLogin() {
        setRegistering(true);

    }
    function cancelLogging() {
        setRegistering(false);
    }
    function finishLogging() {
        setRegistering(false);
    }


    async function reserve() {
        setReserving(false);
        if (userContext.user === undefined) {
            return startLogin();
        }

        try {
            setConfirming(true);
            const reservationResponse = await reservationClient.reserve(slsOrd, userContext.user);
            await invalidateData();
        } finally {
            setConfirming(false);
        }
    }
    function getOptName(selectionId:string) {
        const opt = slsOrd.options.find(soo => soo.selectionID === selectionId);
        if (opt?.selectionID === "WH_DESIGNPKG") {
            return "Interior Design Package: " + opt.style;
        }
        if (opt?.selectionID === "GARAGE") {
            if (opt.valueName === "Not Selected") {
                return "No Garage";
            }
            return opt.valueName;
        }
        return opt?.valueName ?? "";

    }
    // -1 if not on waitlist.
    const waitlistPosition = slsOrd.waitlist.findIndex(elem => elem === userContext.user?.id);

    return <SiteSpecificSelectionsDiv>
        { isReserving && <DialogDiv><PurchaseOverlay onClose={() => setReserving(false)} onConfirm={reserve}>
            { slsOrd.reservedTo === 0 && <>
            <h3>Are you sure you want to reserve this home?</h3>
            <p>A sales representative will be notified of your selection and work up final paperwork</p>
            </> }
            { slsOrd.reservedTo !== 0 && <>
                <h3>Are you sure you want to join the waitlist?</h3>
                <p><span className={"seatName"}>Seat #{slsOrd.waitlist.length + 1}</span> is currently available on this waitlist</p>

            </> }


        </PurchaseOverlay>
        </DialogDiv> }

        { isRegistering && <DialogDiv><RegistrationOverlay onComplete={finishLogging} onCancel={cancelLogging}></RegistrationOverlay> </DialogDiv> }
        { isConfirming && <DialogDiv></DialogDiv> }

        <div className={"mainContent"}>
            <a href='#' onClick={(ev: React.MouseEvent) => {ev.preventDefault(); navigate(-1); } } className={"back"}>
                &lt; Back</a>


            <h4>Model</h4>
            <OptionLine optionName={slsOrd.marketingName} />
            <OptionLine optionName={getOptName("ELEVATION")} />

            <h4>Color Package</h4>
            { getOptName("EXT_COLORS").split(" / ").map(colorElement => <OptionLine optionName={colorElement} />) }

            <h4>Options</h4>
            { optionsToBeShown.map(opt => {
                if (slsOrd.options.find(soo => soo.selectionID === opt) !== undefined) {
                    return <OptionLine key={opt} optionName={getOptName(opt)} />
                }
            })
            }
        </div>
        <div className={"reserve"}>

            { // Reserve disabled
                // waitlistPosition === -1 && <button disabled={isReserving}
                 //   onClick={() => setReserving(true)}>{slsOrd.reservedTo === 0 ? "Reserve" : "Join Waitlist"}</button>
            }
            { waitlistPosition !== -1 && <button onClick={leaveWaitlist}>Leave Waitlist</button> }
        </div>


    </SiteSpecificSelectionsDiv>

}

export const DialogDiv = styled.div`
position:fixed;
  display:flex;
  justify-content:center;
  align-content:center;
  top:0;bottom:0;right:0;left:0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1;
  > * {
    align-self: center;justify-self:center;
  }
  
`


const ViewsSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap:24px;
    .button {
      background-color: #ffffff;
      border-radius:8px;
      
      display: flex;
      justify-content: center;
      align-items: center;
      width: 145px;
      height:74px;
    }
  .button.active {
    background-color: var(--primary-color);
    color: #fff;
  }
`
interface IView {
    name: string;
    cameraId: string;
    floorplanCameraId: string;
}
export const Views: React.FC<{ views: string[], currentView: string, setView: (view:string) => void}> = (props) => {
    const { views, currentView, setView } = props;



    return <ViewsSection>
        <h2>Views</h2>
        { views.map(view => <div className={"button " + (view === currentView ? "active" : "notactive")} onClick={() => setView(view)}>{ view }</div>) }

    </ViewsSection>
}


interface IFloorplanProps {
    images: IImages;
    view: string;
    modelRid: number;
    camera: string;
    onSetCamera:(camera:string) => void;

}


const FloorplanDiv = styled.div`
    display:flex;
    position:relative;
    flex-direction:column;
    align-items: center;
    justify-content: center;
    background-color: white;
  .container {
    width:550px;
    height:550px;
    position:relative;
  }
 img {
   position: absolute;
  top:0;left:0;
    max-width:550px;
    max-height:550px;
  }
  .overlay {
  /*  position: absolute;
&*    top:0;
    max-width:750px;
    max-height:750px;

    left:0;
    
   */
    
    position:absolute;
    top:0;
    left:0;

  }
`




export type IViewVideo = {
    type: "video",
    name: string,
    video: string,
    looping?: boolean,
    description?: string,
    condition?: string[]
}

export type IViewCamera = {
    type: "camera",
    name: string,
    camera: string,
    description?: string,
    /// If not set, then "All"
    levelgroup?: string,
    // If set, lists out the conditions when this camera should be shown
    // For now, we only support "markethome" in which case the camera is only present for market homes.
    condition?: string[]
}

export type IViewMap = {
    /**
     * 2D community map
     */
    type: "map",
    name: string,
    condition?: string[]
    description?: string,
    /**
     * Optionally specify the SVG viewbox.
     * X, Y, Width, Height
     */
    viewBox?: [number, number, number, number]


}

export type IViewItemImage = {
    /**
     * Shows a named image attached to the slsord (or maybe later the community),
     * e.g. firstfloor or elevation
     */
    type: "image",
    name: string,
    // "elevation", "firstfloor" etc.
    imageId:string;
    condition?: string[],
    description?: string
}

export type IViewItemConfig = IViewCamera | IViewVideo | IViewMap | IViewItemImage

export interface IViewConfig {
    name: string;
    items: IViewItemConfig[];
}

export type IOptionConfig = string | { id: string, name: string };


export interface IModelConfig {
    views: IViewConfig[];
    options: IOptionConfig[];
    /**
     * What is the ID used in unreal, e.g. for Kova model 9981CO the unreal ID might be 9981.
     * If undefined, then kova model ID = unreal model ID.
     */
    unrealId?: string;

    /**
     * What is the Lot ID used in unreal. If not specified, then "GenLot"
     */
    lotId?: string;
}
export function filterViewItems(viewItems: IViewItemConfig[], conditions: string[]) {

    // Filter out all viewitems where we can't find a required condition in the conditions array.
    return viewItems.filter(vi => {
        for (const vic of vi.condition ?? []) {
            if (!conditions.includes(vic)) {
                return false;
            }
        }
        return true;
    });
}
export interface ISiteSpecificProps {
    slsOrds: ISlsOrd[],
    favorites: Set<number>,
    updateFavorites: (favorites:Set<number>) => void
}
const SiteSpecific2DMap: React.FC<{slsOrd: ISlsOrd, slsOrds: ISlsOrd[], selectedViewItem: IViewMap}> = (props) => {
    const { slsOrds, slsOrd } = props;
    return <BigScreenCommunityMap slsOrd={slsOrd} viewBox={props.selectedViewItem.viewBox}/>
}
const SiteSpecific3DMap: React.FC<{slsOrds: ISlsOrd[], slsOrd: ISlsOrd, selectedViewItem: IViewItemConfig, showFurniture: boolean}> = (props) => {
    const { slsOrds, slsOrd, selectedViewItem, showFurniture } = props;
    const bigScreenItems: IBigScreenCommunity3DItems[] = [];
    for (const so of slsOrds) {
        bigScreenItems.push(so.id === slsOrd.id ? ({
            slsOrd: so,
            levelGroup: ((selectedViewItem && selectedViewItem.type === "camera") ? (selectedViewItem?.levelgroup ?? "All") : "All") + (showFurniture ? "_Furn" : ""),
            showParking: true
        }) : ({
            slsOrd: so,
            levelGroup: "All",
            showParking: false
        }));
    }
    const cameraId = (selectedViewItem && selectedViewItem.type === "camera") ? getCameraPrefixForSlsOrd(slsOrd) + selectedViewItem.camera : null;

    return  <BigScreenCommunity3D camera={cameraId}
                                  items={bigScreenItems}
                                  parkedCar={[slsOrd, "EV"]}
    />;
}
const SiteSpecific: React.FC<ISiteSpecificProps> = (props) => {


    const {slsOrds, favorites, updateFavorites} = props;
    const vscContext = useVscContext();
    let [searchParams, setSearchParams] = useSearchParams();
    const id = searchParams.get("id");
    const [viewItemIndex, setViewItemIndex] = useState<number>(0);
    const [activeViewTab, setActiveViewTab] = useState<string | null>(null);
    const [showFurniture, setShowFurniture] = useState<boolean>(true);
    if (slsOrds === null) throw new Error("no slsords");
    const slsOrd = slsOrds.find(h => h.id === id) ?? slsOrds[0];

    const modelConfig = useModelConfig(slsOrd.modelId ?? "");

    if (modelConfig === null) return null;
    const isFavorite = favorites.has(parseInt(slsOrd.id));

    function setFavorite(slsOrdId: number, isFavorite: boolean) {
        const updFavorites = new Set(favorites);
        if (isFavorite) {
            updFavorites.add(slsOrdId);
        } else {
            updFavorites.delete(slsOrdId);
        }
        updateFavorites(updFavorites);
    }


    let title: React.ReactNode = slsOrd.marketingName;
    if (slsOrd.reservedTo !== 0) {
        title = <>{title}: <span style={{color: ThemeColors.gold}}>Pending Sale</span></>
    } else {
        if (slsOrd.isSold) {
            title = <>{title}: <span style={{color: ThemeColors.gold}}>Sold</span></>
        }
    }


    // We enable furniture if we have even one view item with a camera.
    const enableFurniture = modelConfig.views.flatMap(v => v.items).find(itm => itm.type === "camera") !== undefined;
    const viewTabs = modelConfig.views.map(v => v.name) ?? [];
    const activeTabToUse = activeViewTab ?? viewTabs[0] ?? "";

    const allViewItems = getItemsForTab(activeTabToUse, modelConfig);
    const viewItems = filterViewItems(allViewItems, ["markethome"]);
    let selectedViewItem = viewItems[viewItemIndex];
    if (!selectedViewItem) {
        selectedViewItem = viewItems[0];
    }
    
    return <PlanLayout>
        <div className={"content"}>
            <SiteSpecificDiv>
                { selectedViewItem.type === "camera" && <SiteSpecific3DMap slsOrds={slsOrds} slsOrd={slsOrd} selectedViewItem={selectedViewItem} showFurniture={showFurniture} /> }

                { selectedViewItem.type === "map" && <SiteSpecific2DMap slsOrds={slsOrds} slsOrd={slsOrd} selectedViewItem={selectedViewItem}/> }
                { selectedViewItem.type === "image" && <VscBigScreenWebPage url={`StaticContent.html?shared=global&image=${encodeURIComponent(vscContext.getVisualizerControllerUri(slsOrd.images[selectedViewItem.imageId as keyof IImages]!))}`} /> }
                <div className={"views"}>
                    <ViewTabs viewTabs={viewTabs} activeViewTab={activeTabToUse}
                              onSetActiveViewTab={(tabName: string) => {
                                  setViewItemIndex(0);
                                  setActiveViewTab(tabName);
                              }}/>
                    <div className={"cameras"}>
                        {viewItems.map((cam, idx) => <CameraCard key={idx} camera={cam} isActive={idx === viewItemIndex} onClick={() => setViewItemIndex(idx)}/>)}
                    </div>

                </div>

                <div className={"selections"}>
                    <SiteSpecificSelections slsOrd={slsOrd}
                                            isFavorite={isFavorite}
                                            setFavorite={(val) => setFavorite(parseInt(slsOrd.id), val)}

                    />
                </div>

            </SiteSpecificDiv>
        </div>
        <div className={"footer"}>
            { (enableFurniture) && <FurnitureSwitch checked={showFurniture} onChange={() => setShowFurniture(old => !old)}/> }
        </div>
    </PlanLayout>
}

export default SiteSpecific;